import debug from './debug.json'
import build from './build.json'

//'babel-plugin-transform-inline-environment-variables' (http://survivejs.com/webpack/building-with-webpack/setting-environment-variables/)
const Environment = process.env.npm_lifecycle_event.indexOf('start') !== -1 ? debug : build

export default Environment
